export default __webpack_public_path__ + "936cf6c6ffa7b2f66e2991fee32b534a.svg";